import EcoNavProduct, { EcoNavProductItemProps, EcoNavProductProps } from 'eco-design/sections/eco-nav-product';
import { useRouter } from 'next/router';
import { productPageUrl } from '../../config/pageConfig';
import { IPageStatus } from '../../config/IPageStatus';
import { useProductStore } from '../../ProductProvider';
import styles from './index.module.scss';
import { LangText } from './LangText';
import gtm from '@/utils/gtm';

export default function ProductNav({ activeTab, tabCallback, buyLink }: { activeTab: string; tabCallback?: any; buyLink: string }) {
    const { locale = 'us', pathname, asPath } = useRouter();
    const TextA = LangText[locale] || LangText['us'];
    const thePageUrl = `/${locale}/${productPageUrl}`;
    const isInProductPage = pathname.endsWith(productPageUrl);

    const query = String(asPath.split('?')[1])?.split('#')[0];
    const { pageStatus } = useProductStore();

    const IS_AU_SITE = ['au'].includes(locale);
    const IS_JP_SITE = ['jp'].includes(locale);
    const IS_NA_SITE = ['us', 'ca'].includes(locale);
    const IS_EU_SITE = ['eu', 'uk', 'fr', 'de', 'it', 'es'].includes(locale);
    const dataA: EcoNavProductProps = {
        tabItems: [
            {
                value: 'Product',
                label: TextA.tab_product,
                href: isInProductPage ? undefined : `${thePageUrl}${query !== 'undefined' ? `?${query}` : ''}`,
            },
            IS_NA_SITE &&
                pageStatus !== IPageStatus.statusA && {
                    value: 'Bundles',
                    label: TextA.tab_bundles,
                    href: `${thePageUrl}/bundles${query !== 'undefined' ? `?${query}` : ''}`,
                },
            {
                value: 'Support',
                label: TextA.tab_support,
                href: `${thePageUrl}/support${query !== 'undefined' ? `?${query}` : ''}`,
            },
            {
                value: 'Specs',
                label: TextA.tab_specs,
                href: `${thePageUrl}/specs${query !== 'undefined' ? `?${query}` : ''}`,
            },
        ].filter(Boolean) as EcoNavProductItemProps[],
        buyItems: [
            IS_NA_SITE &&
                (pageStatus === IPageStatus.statusA || buyLink) && {
                    value: 'Button',
                    label: pageStatus === IPageStatus.statusA ? TextA.btn_subscribe : TextA.btn_buy,
                    href: pageStatus === IPageStatus.statusA ? `${thePageUrl}${query !== 'undefined' ? `?${query}` : ''}#Banner` : buyLink,
                },
            IS_EU_SITE &&
                (pageStatus === IPageStatus.statusA || buyLink) && {
                    value: 'Button',
                    label: pageStatus === IPageStatus.statusA ? TextA.btn_subscribe : TextA.btn_buy,
                    href: pageStatus === IPageStatus.statusA ? `${thePageUrl}${query !== 'undefined' ? `?${query}` : ''}#SectionA2` : buyLink,
                },
            IS_JP_SITE && {
                value: 'Button',
                label: TextA.btn_buy,
                href: `${thePageUrl}/bundles${query !== 'undefined' ? `?${query}` : ''}`,
            },
            IS_AU_SITE &&
                pageStatus !== IPageStatus.statusA && {
                    value: 'Button',
                    label: TextA.btn_buy,
                    href: 'https://au.ecoflow.com/products/ecoflow-wave-3-portable-air-conditioner',
                },
        ].filter(Boolean) as EcoNavProductItemProps[],
    };
    const tabChange = (item: any, _: number) => {
        if (tabCallback) {
            tabCallback(item.value);
        }
    };
    const buyChange = (item: any, _: number) => {
        if (IS_JP_SITE) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'product_navigation',
                product_name: 'EcoFlow WAVE 3',
                navigation_name: item.label,
            });
        }
    };
    return (
        <div className={styles.comp}>
            <EcoNavProduct
                productItems={[
                    {
                        value: 'name1',
                        label: TextA.product_name,
                        href: thePageUrl,
                    },
                ]}
                {...dataA}
                defaultTabActiveKey={activeTab}
                onTabChange={tabChange}
                onBuyChange={buyChange}
            />
        </div>
    );
}
